function cov_26lhho9ffr() {
  var path = "/Users/danny.su@opendoor.com/od/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts";
  var hash = "545afcf6b64824522114b568b75c6310c45405b6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Users/danny.su@opendoor.com/od/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "545afcf6b64824522114b568b75c6310c45405b6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26lhho9ffr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_26lhho9ffr();
export { PropertyCard } from "./PropertyCard.mjs";
//# sourceMappingURL=index.mjs.map